class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

        open(triggeredBy) {
              let resultArray = [];
              async function fetchProductData(productId) {
              const response = await fetch(`/products/${productId}.js`);
              if (!response.ok) {
                  throw new Error('Failed to fetch product data');
              }
                return response.json();
          }
          fetch("/cart.js")
            .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
              return response.json();
          })
          .then(data => {
          if(data.total_price == 0)
          {
              setTimeout(function() { $('#CartDrawer-Checkout').prop('disabled', true); }, 1000);
          }
          data.items.forEach(async item => {
              const productData = await fetchProductData(item.handle);
              try {
              const productData = await fetchProductData(item.handle);
              var ntag = productData.tags;
              resultArray.push(ntag);
              } catch (error) {
              console.error(`Error fetching product data for product "${item.title}":`, error);
              }
          });
              /*setTimeout(function() {
                  function wordExistsInArray(word, array) {
                        for (var i = 0; i < array.length; i++) {
                          for (var j = 0; j < array[i].length; j++) {
                            if (array[i][j] === word) {
                              return true; // Word found
                            }
                          }
                      }
                      return false; // Word not found
                    }
                    var wordToFind = "free1";
                    if (wordExistsInArray(wordToFind, resultArray) || data.total_price == 0) {
                        $('#myPopup').addClass('hide');
                        $('.header__icon.header__icon--cart').trigger('click');
                    } else {
                        $('.header__icon.header__icon--cart').trigger('click');
                        $('#cust_popup').trigger('click');
                        $('#myPopup').removeClass('hide');
                    }
            }, 1000);
          */
            setTimeout(function() {
              var cprice = data.total_price/100;
              function wordExistsInArray(word, array) {
                for (var i = 0; i < array.length; i++) {
                  for (var j = 0; j < array[i].length; j++) {
                    if (array[i][j] === word) {
                        return true; // Word found
                    }
                  }
                }
                return false; // Word not found
              }
                var wtf1 = "first";
                var wtf2 = "second";
                var wtf3 = "forth";
                var wtf4 = "fifth";
                
                if (wordExistsInArray(wtf1, resultArray) && cprice <= 0) {
                $('#CartDrawer-Checkout').prop('disabled', true);
                } else if (wordExistsInArray(wtf2, resultArray) && cprice < 101) {
                $('#CartDrawer-Checkout').prop('disabled', true);
                } else {
                $('#CartDrawer-Checkout').prop('disabled', false);
                }
              }, 1000);
            })
            .catch(error => {
            console.error('There was a problem fetching the cart:', error);
            });
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
          setTimeout(() => {
          });
        this.addEventListener(
          'transitionend',
          () => {
            const containerToTrapFocusOn = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            trapFocus(containerToTrapFocusOn, focusElement);
          },
          { once: true }
        );
                fetch("/cart.js").then(function(a) {
              return a.json()
            }).then(function(a) {
                  setTimeout(() => { 
                 });    
            });
        }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
